import { Stack } from "@/ui/components/layout";
import { TextBody } from "@/ui/components/typography/TextBody";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import { FC } from "react";
import { TArticleFeedHeaderProps } from "./ArticleFeed.config";

export const ArticleFeedHeader: FC<TArticleFeedHeaderProps> = ({ title, body }) => {

  if (!title && !body) {
    return null;
  }

  return (
    <Stack gap="3">
      { title ? (
        <TextSubtitle size={2}>{ title }</TextSubtitle>
      ) : null }
      { body ? (
        <TextBody>{ body }</TextBody>
      ) : null }
    </Stack>
  );
};
